if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener('click', (event) => {
          const previous = event.target.closest('[data-barros-modal-prev]');
          const next = event.target.closest('[data-barros-modal-next]');

          if (previous) {
            event.preventDefault();
            event.stopPropagation();
            this.navigateMedia(-1);
          }

          if (next) {
            event.preventDefault();
            event.stopPropagation();
            this.navigateMedia(1);
          }
        });

        // BARROS: prevent Dawn's generic media-modal pointerup handler
        // from closing the lightbox when the user clicks the image or arrows.
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) {
          dialog.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
        }

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') this.navigateMedia(-1);
          if (event.key === 'ArrowRight') this.navigateMedia(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'))
          .filter((element) => !element.classList.contains('product__media-item--variant') || !element.hidden);
      }

      navigateMedia(direction) {
        const items = this.getMediaItems();
        if (items.length < 2) return;

        let currentIndex = items.findIndex((item) => item.classList.contains('active'));
        if (currentIndex < 0) currentIndex = 0;

        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.activateMedia(items[nextIndex]);
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;

        this.getMediaItems().forEach((element) => element.classList.remove('active'));
        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        this.activateMedia(activeMedia);
      }
    }
  );
}
